import React, { useState, useEffect, useRef } from 'react';
import './CustomeDropdown.css'; // Import your CSS file for styling
import chevronDown from '@ingka/ssr-icon/paths/chevron-down-small';
import SSRIcon from '@ingka/ssr-icon';

function CustomDropdown({ onChange, item }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Select Market');
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option, country, lang) => {
    setSelectedOption(option);
    setIsOpen(false);
    onChange(country, lang.substring(0, 2));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <div className="custom-select" ref={dropdownRef}>
      <div className="select-selected" onClick={toggleDropdown}>
        {selectedOption}
        <div className={`arrow ${isOpen ? 'open' : ''}`}>
          <SSRIcon style={{ color: '#70757a' }} paths={chevronDown} />
        </div>
      </div>
      {isOpen && (
        <div className={`select-items ${isOpen ? 'show' : ''}`}>
          {item.map((option, index) => (
            <div
              key={index}
              className={`select-item ${selectedOption === option.displayLabel ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option.displayLabel, option.countryCode, option.languageCode)}
            >
              {option.displayLabel}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
